<template>
  <div class="wait-screen">
    <StepHeader>
      <h1>Personalizing Your Offer</h1>
    </StepHeader>

    <WaitScreenLoadingBar :visible="loadingBarVisible" />
    <WaitScreenAnimation
      v-observe-visibility="{
        callback: animationVisibilityChanged,
        intersection: {
          threshold: 0.25
        },
      }"
    />
    <WaitScreenAwards />
    <WaitScreenReviews />
  </div>
</template>

<script>
import StepHeader from '@/components/common/step-layout/StepHeader'
import WaitScreenLoadingBar from './WaitScreenLoadingBar.vue'
import WaitScreenAnimation from './WaitScreenAnimation.vue'
import WaitScreenAwards from './WaitScreenAwards.vue'
import WaitScreenReviews from './WaitScreenReviews.vue'
import polling from '@/mixins/delay/polling'
import DataLayer from '@/utilities/data-layer'

export default {
  name: 'WaitScreen',
  components: {
    StepHeader,
    WaitScreenLoadingBar,
    WaitScreenAnimation,
    WaitScreenAwards,
    WaitScreenReviews
  },

  mixins: [
    polling
  ],

  data () {
    return {
      loadingBarVisible: false
    }
  },

  mounted () {
    DataLayer.pushObject({
      event: 'spring_ploan_delay_display'
    })
    setTimeout(() => {
      this.pollProductEligibility()
    }, 3000)
  },

  methods: {
    animationVisibilityChanged (isVisible) {
      this.loadingBarVisible = !isVisible
    }
  }
}
</script>

<style lang='scss' scoped>
.wait-screen {
  @apply mt-35;
}
</style>
